module.exports = __webpack_public_path__ + "img/standort_pfarrei-st-martin_2.5c812b5f.png";